export default __webpack_public_path__ + "assets/images/New-Experience-949299f0d40f4e495b2891167063c3d1.svg";